module.exports = __webpack_public_path__ + "static/media/events.ae24ee5d.png";